// Order conditions that hold a list of product / variant ids ({ oneOf: [ids] })
export const ORDER_ITEM_CONDITIONS = ["products", "variants"];
